// removed by extract-text-webpack-plugin
module.exports = {"base":"Card_base--3GwCH","flipWrapper":"Card_flipWrapper--3HhI4","flipBack":"Card_flipBack--ZHsDd","flip":"Card_flip--8TCYF","front":"Card_front--25Kj4","back":"Card_back--rtep8"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/Card.scss
// module id = 2264
// module chunks = 11